import {createActionGroup, emptyProps, props} from "@ngrx/store";
import {DealSensitivityOverview} from "../../models/deal-sensitivity-overview";
import {DealSensitivity} from "../../models/deal-sensitivity";
import {ComputeSensitivitiesRequest} from "../../generated-sources/api/deal/model/compute-sensitivities-request";

export const DealSensitivityActions = createActionGroup({
    source: "Deal Sensitivity Actions",
    events: {
        load: props<{ dealId: number }>(),
        loadSuccess: props<{ dealSensitivityOverview: DealSensitivityOverview }>(),
        loadError: props<{ errorMsg: string }>(),

        compute: props<{
            dealId: number;
            paramType: ComputeSensitivitiesRequest.ParamTypeEnum;
            step: number;
            steps: number;
        }>(),
        computeSuccess: props<{ dealSensitivityOverview: DealSensitivityOverview }>(),
        computeError: props<{ errorMsg: string }>(),

        setColumnTokens: props<{ tokens: string[] }>(),

        clearState: emptyProps()
    }
});

export const DealSensitivityDetailsActions = createActionGroup({
    source: "Deal Sensitivity Details Actions",
    events: {
        load: props<{ dealId: number, dealSensitivityId: number }>(),
        loadSuccess: props<{ dealSensitivity: DealSensitivity }>(),
        loadError: props<{ errorMsg: string }>()
    }
});
